import React, { useEffect, useState,useRef } from "react";
import { Formik, Field, Form} from "formik";
import FormikTextField from '../components/formikcomponent/TextField';
import FormikSelectWithLabel from "../components/formikcomponent/SelectFieldWithLabel";
import Formikdatapicker from '../components/formikcomponent/DataPicker';
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import { Typography, makeStyles, Button, InputLabel, InputAdornment, Grid, Paper } from '@material-ui/core';
import Bodycontent from "./NewContentBody";
import JsonPreview from "./JsonPreview";
import {object} from 'yup';
import AreaField from '../components/Fields/VeevaContentId';
import { v4 as uuidv4 } from "uuid";
import File from '../components/formikcomponent/Imageinput';
import category from './category';
import {StatusCodes} from 'http-status-codes';
import jsontopic from './topic';
import Constants from '../components/Fields/DropDownList';
import GridContainer from "../components/Grid/GridContainer";
import GridItem from "../components/Grid/GridItem";
import Multiselectinput from '../components/formikcomponent/MutiSelectinput';
import formikVideo from './VideoFile';
import AuthenticatedPage from "../ContextAndHOC/AuthenticatedPage";
import ErrorDialog from '../components/ErrorDialog';
import SuccessDialog from '../components/SuccessDialog';
import Resourceid  from '../components/Fields/Resource';
import Targetaction from'../components/Fields/Targetactionid';
import Persona from'../components/Fields/Persona';
import DrugCategory from '../components/Fields/DrugCategory';
import DiseaseSegment from'../components/Fields/DiseaseSegment';
import CircularProgress from '@material-ui/core/CircularProgress';
import Fieldtext from '../components/Fields/FieldText';
import Trigger from '../components/Fields/Trigger';
import TreatmentPhase from '../components/Fields/TreatmentPhase';
import Objective from "../components/Fields/Objective";
import CategoryTag from '../components/Fields/CategoryTag';
import TopicTag from '../components/Fields/TopicTag';
import {articleYup,articleContentIf, articleContentElse} from "../components/CSSDuplicatedBlocks";
const  FormikArticleForm= (props) => {
let validateWithSchema = null;
const useStyles = makeStyles(theme => ({
  heading: { maxWidth:'1100px', margin:'auto', marginTop:'20px', fontSize: "40px", textAlign: "left", textDecoration: "none", color:'rgb(6, 48, 63)' },
  para: { padding: "15px", paddingLeft: "50px" },
  image: { marginBottom: "5px" },
  holder:{backgroundColor:'white', paddingTop:'30px'},
  main:{ maxWidth:'1100px', margin:'auto'},
  paddingBottom: { paddingBottom: "30px" },
  successDialogOK: {color: theme.palette.text.textPrimaryColor, backgroundColor: theme.palette.primary.main, border: `1px solid${theme.palette.border.primaryBorder}`,
  borderRadius: "50px", margin: "8px 0", textAlign: "right", padding: "7px 15px", '&:hover': { backgroundColor: theme.palette.hoverPrimaryColor.main,
  color: theme.palette.text.hoverTextPrimaryColor, border: `1px solid ${theme.palette.border.hoverPrimaryBorder}` }},
  inputItem: { width: "100%" },
  createUserSelect: { '& p': { maxWidth: "200px",textOverflow: "ellipsis",display: "inline-block",overflow: "hidden",whiteSpace: "nowrap !important"} },
  para1: { float: "right", paddingRight: "20px" },
  createUser: {color: theme.palette.text.textPrimaryColor, backgroundColor: theme.palette.primary.main, border: `1px solid${theme.palette.border.primaryBorder}`,minWidth: 242,
  borderRadius: "50px", margin: "0 8px", textAlign: "right", padding: "7px 20px", textTransform: "uppercase", '&:hover': { backgroundColor: theme.palette.hoverPrimaryColor.main,
  color: theme.palette.text.hoverTextPrimaryColor, border: `1px solid ${theme.palette.border.hoverPrimaryBorder}`, }},
  sucessbtn:{minWidth: "100px !important", textTransform: "uppercase", backgroundColor: "rgba(75, 123, 227, 1)", color: '#fff', borderRadius: "25px", border: "1px solid ", marginLeft: "16px",
 fontWeight: "500 !important",'&:hover': { color: '#1d5d90',  border: "1px solid " },},
  cancelBtn: { width: "242px", height: "40px", textTransform: "uppercase", backgroundColor: "rgba(255, 255, 255, 1)", color: "rgba(75, 123, 227, 1)",
  borderRadius: "25px", border: "1px solid rgba(0, 0, 0, 0.12)", marginLeft: 25, fontWeight: "500 !important",
  '&:hover': { color: '#1d5d90',  border: "1px solid " },
  [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginLeft:0
  }},
  gridHeader: { paddingLeft: "5px", paddingBottom: "25px", paddingTop: "5px" },
  clr_title: { color: "rgba(74, 74, 74, 1)", fontSize: "20px" },
  button: { height: "40px", marginRight: "20px", backgroundColor: "#2262bf", color: "white", paddingTop: "7px", width:'100%', paddingBottom: "7px", fontSize: "13.7px", whiteSpace: "nowrap", cursor: "pointer",
  borderRadius: "50px", [theme.breakpoints.down("sm")]: { fontSize: '12px', minWidth: "120px" }, '&:hover': { opacity:'0.8', transition:'0.2s' , backgroundColor:'#2262bf'} },
  errormessage:{color:"#f44336",fontSize:" 0.75rem",paddingTop:"3px"},
}));
 const classes = useStyles();
const[apiTopic,setApiTopic]=React.useState(false);
const[locationsearch,setLocationsearch]=React.useState();
const[Errorclose,setErrorClose]=React.useState(false);
const[editvalue,setEditValue]=React.useState(false);
 const [selectedarticledata, setSelectedArticledata] = useState({
        type: 3,
        title: "",
       category:'',
       isdeleted:0,
       resourceid:"",
       topicid:[],
       trigger:[],
       content: {
           author: "",
           publication: "",
           publishedDate: "",
           expirationDate: "",
           readTime: "",
           videoUrl:"",
           articleImage:"",
           thumbnail: "",
          contentBody: "",
           mediaCaption: "",
           shortDescription: "",
           longDescription: "",
           disclaimerOne:'',
          disclaimerTwo:""
       },
       categorytag:[],
       topictag:[],
       diseasesegment:[],
       treatmentphase: [],
         drugcategory:[],
     persona:[],
searchtags:'',
objective:[],
targetactionid:'',
});

  const [open, setOpen] = useState(false);
  const [body, setBody] = useState(false);
  const [Contentbody, setContenBody] = useState([]);
  const [openpopup, setOpenpopup] = useState(false);
  const [SucessField, setSucessfield] = useState(false);
  const [topic, setTopic] = useState();
  const [catagorydata, setCatagorydata] = useState();
  const [newcategoryvalue, setNewcategoryvalue] = useState(0);
  const [topicidvalue, setTopicidvalue] = useState();
  const [data, setData] = useState(false);
  const [load, setLoad] = useState(false);
  const [UpdatedMessage, setUpdatedMessage] = useState("");
  const[disablesubmit,setDisableSubmit]= useState(false);
  const[resourceidError,setResourceidError]=useState(false);
  const [ImageErrorclosearticle, setImageErrorClosearticle] = React.useState(false);
const handleCloseDialog = () => {
      setOpen(false);
      setSucessfield(false);
      props.history.push("/Home/Article");
  };
 const handleErrorUser = () => {
    setOpen(false);
    setErrorClose(false);
    setImageErrorClosearticle(false);
    setResourceidError(false);
  };
const InactivatePatientButton = [<Button className={classes.successDialogOK} onClick={handleCloseDialog}>{"OK"}</Button>];
const InactivatePatientButton1 = [<Button className={classes.successDialogOK} onClick={handleErrorUser}>{"OK"}</Button>];

const sendSucess = () => {
    setOpen(true);
    setSucessfield(true);
  };
  const sendError = () => {
    setOpen(true);
    setErrorClose(true);
  };
const formikRef = useRef();
    let SuccessMessage = "Content has been created successfully.";
    let errorMessage1 = "Please check Content ID already exit.";
    let resourceMessage="Please enter Content ID before entering Content Body.";
const triggerValue = Constants.triggeroption;
const categoryValue=Constants.categoryValue;
const objectiveValue=Constants.objectiveValue;
const treatmentPhaseValue=Constants.treatmentPhaseValue;
const diseaseSegmentValue=Constants.diseaseSegmentValue;
const drugCategoryarticleValue=Constants.drugCategoryValue;
const personaArticleValue=Constants.personaValue;
const articletargetactionoptions=Constants.targetactionoptions;
const TopictagarticleValue=Constants.TopictagValue;
const params = new Map(props.location.search.slice(1).split('&').map(kv => kv.split('=')));
  if (props.location.state === "video") {
  validateWithSchema = object().shape({
    content:
      object().shape({
       ...articleContentIf
      }),
    ...articleYup
  });
  } else {
    validateWithSchema = object().shape({
      content: object().shape({
        ...articleContentElse
      }),
      ...articleYup
    });
  }
React.useEffect(()=>{
setUpdatedMessage("Content has been Updated successfully.");
if(props.location.clone === "clone"){
  setUpdatedMessage(SuccessMessage);
}
setCatagorydata(category);
setTopic(jsontopic);
const Updatedata=(value,label,name)=>{
  let comingvalue = [];
  if (name === 1) {
    label.find((labelval) => {
      if (labelval.label === value) {
        comingvalue.push({ value: labelval.value, label: labelval.label });
      }
    });
  } else {
    if (value) {
      for (let i = 0; i < value.length; i++) {
        label.find((vale) => {
          if (vale.label === value[i] || vale.label === value) {
            let topic = { value: vale.value, label: vale.label };
            comingvalue.push(topic);
          }
        });
      }
    }
  }
return comingvalue;
};
const GetTopic=(value,idval,valtopic)=>{
 const datavalue = valtopic.filter(val => val.categoryid === idval);
   let comingtopic = [];
if(value){
      for (let i = 0; i < value.length; i++) {
        datavalue.find((valu) => {
          if (valu.topicid === value[i]) {
            let topicval={value:valu.topicid,label:valu.title};
            comingtopic.push(topicval);
          }
        });
      }}
return comingtopic;
};
setLocationsearch(props.location.state);
if(props.location.state!=="video"){
if(props.location.state){
if(props.location.state.detail[0].versionNumber!==props.location.state.detail[0].Version.newversion&&props.location.clone !== "clone"){
setDisableSubmit(true);
}
setEditValue(true);
if(props.location.state.detail &&  selectedarticledata){
  selectedarticledata.id=props.location.state.detail[0].id;
  selectedarticledata.type=props.location.state.detail[0].type;
  selectedarticledata.title=props.location.state.detail[0].title;
  selectedarticledata.category=props.location.state.detail[0].category;
gettopics(props.location.state.detail[0].category);
if(props.location.clone !== "clone"){
  selectedarticledata.resourceid=props.location.state.detail[0].resourceid;
}

selectedarticledata.trigger=Updatedata(props.location.state.detail[0].trigger,triggerValue);
if(selectedarticledata.content && props.location.state.detail[0].content){

  selectedarticledata.content.author=props.location.state.detail[0].content.author;

selectedarticledata.content.publication=props.location.state.detail[0].content.publication;
  if(props.location.state.detail[0].content.publishedDate==="N/A")  {
selectedarticledata.content.publishedDate='';
} else{
let date=new Date(props.location.state.detail[0].content.publishedDate);
selectedarticledata.content.publishedDate=date;
}
if(props.location.state.detail[0].content.publishedDate==="N/A")  {
selectedarticledata.content.publishedDate='';
} else{
selectedarticledata.content.expirationDate=new Date(props.location.state.detail[0].content.expirationDate);
}
if(props.location.state.detail[0].content.publishedDate==="N/A")  {
selectedarticledata.content.publishedDate='';
} else{
selectedarticledata.content.expirationDate=new Date(props.location.state.detail[0].content.expirationDate);
}
selectedarticledata.content.readTime=props.location.state.detail[0].content.readTime;
if(props.location.state.detail[0].content.videoUrl ||(props.location.state.detail[0].subtype==="video") ){
setData(true);
selectedarticledata.content.videoUrl=props.location.state.detail[0].content.videoUrl;
}
selectedarticledata.content.thumbnail=props.location.state.detail[0].content.articleImage;
selectedarticledata.content.articleImage=props.location.state.detail[0].content.articleImage;
selectedarticledata.content.contentBody=props.location.state.detail[0].content.contentBody;
selectedarticledata.content.mediaCaption=props.location.state.detail[0].content.mediaCaption;
selectedarticledata.content.shortDescription=props.location.state.detail[0].content.shortDescription;
selectedarticledata.content.longDescription=props.location.state.detail[0].content.longDescription;
if(props.location.state.detail[0].disclaimerOne!==''){
selectedarticledata.content.disclaimerOne=props.location.state.detail[0].content.disclaimerOne;
}
if(props.location.state.detail[0].disclaimerTwo!==''){
selectedarticledata.content.disclaimerTwo=props.location.state.detail[0].content.disclaimerTwo;
}
}
selectedarticledata.categorytag=Updatedata(props.location.state.detail[0].categorytag,categoryValue);
selectedarticledata.topictag=Updatedata(props.location.state.detail[0].topictag,TopictagarticleValue);
selectedarticledata.diseasesegment=Updatedata(props.location.state.detail[0].diseasesegment,diseaseSegmentValue);
selectedarticledata.treatmentphase=Updatedata(props.location.state.detail[0].treatmentphase,treatmentPhaseValue);
selectedarticledata.drugcategory=Updatedata(props.location.state.detail[0].drugcategory,drugCategoryarticleValue);
selectedarticledata.persona=Updatedata(props.location.state.detail[0].persona,personaArticleValue);
selectedarticledata.searchtags=(props.location.state.detail[0].searchtags);
selectedarticledata.objective=Updatedata(props.location.state.detail[0].objective,objectiveValue);
if(props.location.newversion_clone){
selectedarticledata.veevacontentid=(props.location.state.detail[0].veevacontentid);}
selectedarticledata.targetactionid=Updatedata(props.location.state.detail[0].targetactionid,articletargetactionoptions,1);
selectedarticledata.targetactionid=selectedarticledata.targetactionid[0];
selectedarticledata.topicid=GetTopic(props.location.state.detail[0].topicid,props.location.state.detail[0].category,jsontopic);

}
setSelectedArticledata(selectedarticledata);
 let parser = new DOMParser();
let doc;
if(selectedarticledata.content){
  doc = parser.parseFromString(selectedarticledata.content.contentBody, "text/html");
}
if(doc){
if(doc.body.childNodes[0].children===undefined){
selectedarticledata.content.contentBody="";
} else{
for(let i=0;i<doc.body.childNodes[0].children.length;i++){
  if ( doc.body.childNodes[0].children[i].tagName === "P" && doc.body.childNodes[0].children[i].style.fontWeight === "500" ) {
  let head = { id: uuidv4(), type: "header", value:doc.body.childNodes[0].children[i].textContent };
    Contentbody.push(head);
  } else if( doc.body.childNodes[0].children[i].tagName === "A" ) {
  let head = { id:  uuidv4(), type: "link", value:doc.body.childNodes[0].children[i].textContent };
    Contentbody.push(head);
  } else if( doc.body.childNodes[0].children[i].tagName === "P" && doc.body.childNodes[0].children[i].style.fontWeight === "400") {
  let head = { id:  uuidv4(), type: "paragraph", value:doc.body.childNodes[0].children[i].textContent, };
    Contentbody.push(head);
  } else if(doc.body.childNodes[0].children[i].tagName === "DIV") {
 const  val=doc.body.childNodes[0].children[i].firstChild.attributes[0].value.replace("{", "");
 let head = { id:  uuidv4(), type: "image", value: "", url:val.replace("}", " ") };
 Contentbody.push(head);
} else if( doc.body.childNodes[0].children[i].tagName === "VIDEO") {
 let head = { id:  uuidv4(), type: "video", value: " ", url:doc.body.childNodes[0].children[i].firstElementChild.src };
 Contentbody.push(head);
  } else if( doc.body.childNodes[0].children[i].tagName === "UL") {
const ulval=[];
 for(let j=0;j<doc.body.childNodes[0].children[i].children.length;j++) {
  let list = { id:  uuidv4(), value:doc.body.childNodes[0].children[i].children[j].textContent };
  ulval.push(list);
  }
  let head = { id:  uuidv4(), type: "list", ul: true, value: ulval };
 Contentbody.push(head);
} else if( doc.body.childNodes[0].children[i].tagName === "OL") {
const olval=[];
 for(let j=0;j<doc.body.childNodes[0].children[i].children.length;j++) {
  let list = { id: uuidv4(), value:doc.body.childNodes[0].children[i].children[j].textContent };
olval.push(list);
}
let head = { id:  uuidv4(), type: "list", ul: false, value: olval };
Contentbody.push(head);
}
}
}
}
}}
},[]);
  useEffect(() => {
    if (catagorydata) {
      const value = catagorydata.filter((cateval) => cateval.categoryid === selectedarticledata.category);
      if (value.length > 0) {
        const newvalue = { value: value[0].categoryid, label: value[0].title };
        selectedarticledata.category = newvalue;
       formikRef.current.setFieldValue("category", newvalue);
      }
    }
    setSelectedArticledata(selectedarticledata);
  }, [catagorydata, topic]);

  const sortcategory = () => {
    if (catagorydata) {
      return catagorydata.sort((a, b) => a.displayorder - b.displayorder);
    }
  };
const imageerror=()=>{
setOpen(true);
setImageErrorClosearticle(true);
};
const imageerrormessage="Images are not saved, Please submit again.";
  const gettopics = (categaoryvalues) => {
let selecttopicoption=[];
    const value = jsontopic.filter(selval => selval.categoryid === categaoryvalues);
    value.map((val) => {
      let selecttopic = { value: val.topicid, label: val.title };
      selecttopicoption.push(selecttopic);
    });
    setTopicidvalue(selecttopicoption);
  };
  useEffect(() => {
    if (apiTopic) {
      formikRef.current.setFieldValue("topicid", []);
        let topicsvalue=[];
        setTopicidvalue(topicsvalue);
      gettopics(newcategoryvalue);
    }
    setApiTopic(true);
  }, [newcategoryvalue]);
 const getfield=(newid)=>{
setNewcategoryvalue(newid.value);
};
  const handlebody = (resourceid,Iderror) => {
  if(resourceid&&(Iderror===undefined||Iderror===''||Iderror===null)){
    setBody(true);
    setOpen(true);
  } else{
  setResourceidError(true);
    setOpen(true);
}
  };
  const handlePreview = () => {
    setOpen(true);
    setOpenpopup(true);
  };
  const handleClose = () => {
    setOpen(false);
    setOpenpopup(false);
    setBody(false);
  };
  let selectOptions = [];
  let categorysval = { value: 0, label: '' };
  if (catagorydata) {
    sortcategory().map((categorys) => {
      categorysval = { value: categorys.categoryid, label: categorys.title };
      return (
        selectOptions.push(categorysval)
      );
    });
  }

  const handleBodysubmit = (value, text, setFieldValue) => {
    let htmlpar;
    htmlpar = `<div style='font-size:$#font-size#$px'>${value}</div> `;
    setOpen(false);
    setBody(false);
    setContenBody(text);
    setFieldValue("content.contentBody", htmlpar);
  };
  const handleDisable = () => {
    if(props.location.clone === "clone"){
      return false;
    }
    if(editvalue){
      return true;
    }
    return false;
  };
  return (
    <>
      {props.location.state === "video" ? <Typography className={classes.heading} component="h5">Video Form</Typography>
      : <Typography className={classes.heading} component="h5">Article/Recipe Form</Typography>}
        <br />
        <Formik
        innerRef={formikRef}
        enableReinitialize={true}
        validator={() => ({})}
        validationSchema={validateWithSchema}
        initialValues={selectedarticledata}
        onSubmit={(values) => {
          setLoad(true);
          let sendingvalue = ({ ...values, content: { ...values.content }});
          let videostring=false;
          if(typeof (values.content.videoUrl) !== "string"&&values.content.videoUrl!==""){
          videostring=true;
            }
          if (typeof (values.category) === "object") {
            sendingvalue.category = values.category.value;
          }
          let maxLength = 150;
          if (values.content.disclaimerOne.length > 150 || values.content.disclaimerTwo.length > 150) {
            sendingvalue.content.disclaimerTwo = values.content.disclaimerTwo.substr(0, maxLength);
            sendingvalue.content.disclaimerOne = values.content.disclaimerOne.substr(0, maxLength);
          }
           if(values.content.disclaimerTwo.length===0){
              sendingvalue.content.disclaimerTwo='N/A';
            }
            if(values.content.disclaimerOne.length===0){
              sendingvalue.content.disclaimerOne='N/A';
            }
          if (values.content.publishedDate === 'N/A'||values.content.publishedDate === '') {
            sendingvalue.content.publishedDate = 'N/A';
          } else {
            sendingvalue.content.publishedDate =values.content.publishedDate.toISOString().split('T')[0];
          }
          if (values.targetactionid === ''||values.targetactionid.length === 0) {
            sendingvalue.targetactionid = 'N/A';
          } else {
            sendingvalue.targetactionid = values.targetactionid.label;
          }
          if (typeof (values.title) === "string") {
            let trigger = [];
            trigger.push(values.title);
            sendingvalue.title = trigger;
          }
          const Geteditvalue = (value) => {
            let trigger = [];
            value.map((obj) => {
              trigger.push(String(obj.label));
            });
            return trigger;
          };
          if (values.topicid) {
            let sendtopic = [];
            values.topicid.map((obj) => {
              sendtopic.push(obj.value);
            });
            sendingvalue.topicid = sendtopic;
          }
          sendingvalue.trigger = Geteditvalue(values.trigger);
          sendingvalue.categorytag = Geteditvalue(values.categorytag);
          sendingvalue.diseasesegment = Geteditvalue(values.diseasesegment);
          sendingvalue.topictag = Geteditvalue(values.topictag);
          sendingvalue.treatmentphase = Geteditvalue(values.treatmentphase);
          sendingvalue.drugcategory = Geteditvalue(values.drugcategory);
          sendingvalue.persona = Geteditvalue(values.persona);
          sendingvalue.objective = Geteditvalue(values.objective);
          let datasearch = [];
          if (typeof (values.searchtags) === "string") {
            let trigger = [];
            datasearch = values.searchtags.split(/[ ,]+/);
            for (let i = 0; i < datasearch.length; i++) {
              trigger.push(`${datasearch[i]}`);
            }
            sendingvalue.searchtags = trigger;
          } else {
            let trigger = [];
            datasearch = values.searchtags;
            for (let i = 0; i < datasearch.length; i++) {
              trigger.push(`${datasearch[i]}`);
            }
            sendingvalue.searchtags = trigger;
          }
          sendingvalue.content.expirationDate = 'N/A';
          if (values.content.videoUrl.length > 0||data) {
            sendingvalue.subtype = "video";
            //sendingvalue.content.videoUrl=values.content.videoUrl;
          } else {
            delete sendingvalue.content.videoUrl;
            sendingvalue.subtype = "";
          }
          async function sendArticle() {
            let url = "";
            url = "/api/content/contentservice/saveArticleResource";
            if(props.history.location.pathname.includes("revision") && props.location.clone !== "clone"){
              url = "/api/content/contentservice/createRevisionForArticleResource";
            }
            if(props.history.location.pathname.includes("version") && props.location.clone !== "clone"){
              url = "/api/content/contentservice/createVersionForArticleResource";
            }
            let response = await props.authenticatedApiCall("post", url, sendingvalue);
            setLoad(false);
            if (response && response.status === StatusCodes.OK) {
              sendSucess();
            }
            if (response && response.status === StatusCodes.BAD_REQUEST) {
              sendError();
            }
          }
          if (values.content.articleImage.base64Rep||videostring) {
            let resdata = [];
            async function sendImage() {
              const data = new FormData();
              for (let i = 0; i < 2; i++) {
                if (i === 0&&values.content.articleImage.base64Rep) {
                  data.append(`imagefile`, values.content.articleImage, `${"Article&" + values.resourceid+"_" +uuidv4()+ "_Image.jpg"}`);
                }
                if (values.content.videoUrl !== "" && i === 1&&typeof (values.content.videoUrl) !== "string") {
                  data.append(`imagefile`, values.content.videoUrl[0], `${"Article&" + values.resourceid +"_"+uuidv4()+ "_Video.mp4"}`);
                }
              }
              let url = "/api/content/contentservice/contentToolFileUpload";
              let response = await props.authenticatedApiCall("post", url, data);
              if (response && response.status === StatusCodes.OK) {
                if (response.data.result) {
                  response.data.result.map((res) => {
                    return resdata.push(props.currentUser.config.s3BucketBaseUrl+res.Key);
                  });
                  if(values.content.articleImage.base64Rep){
                  sendingvalue.content.articleImage = resdata[0];
                  sendingvalue.content.thumbnail = resdata[0];}
                  if (typeof (values.content.videoUrl) !== "string") {
                  if(values.content.articleImage.base64Rep){
                    sendingvalue.content.videoUrl = resdata[1];}
                  else{
                    sendingvalue.content.videoUrl = resdata[0];
                    }
                  }
                }
                sendArticle();
              } else {
                imageerror();
                setLoad(false);
              }
            }
            sendImage();
          } else {
            sendArticle();
          }
        }
        }>
        {({ values, handleChange, setFieldError, validateForm, errors, touched, setFieldValue }) => (
            <Form>
              <div className={classes.main}>
              <div className={classes.holder}>
              <GridContainer>
                <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <Field
                      name={"title"}
                      component={FormikTextField}
                      variant="filled"
                      label="Title *"
                      className={classes.inputItem}
                      onChange={handleChange}
                    />
                </GridItem>
                <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <Field
                      name='category'
                      options={selectOptions}
                      placeholder="Category *"
                      component={FormikSelectWithLabel}
                      label="Category"
                      variant="filled"
                      isSearchable={false}
                      className={classes.createUserSelect + " " + "selectstyle"}
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      onChange={(event)=>{ getfield(event);}}
                    />
                </GridItem>
                <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <Field
                      name='topicid'
                      options={topicidvalue}
                      placeholder="Topic"
                      isSearchable={false}
                      component={Multiselectinput}
                      className={classes.createUserSelect + " " + "selectstyle"}
                      label="Topic *"
                      variant="filled"
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                </GridItem>
                <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                <Resourceid setFieldErrors={setFieldError} disabled={() => handleDisable()}/>
                </GridItem>
                <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                  <Targetaction targetactionoptions={articletargetactionoptions}/>
                </GridItem>
                <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                <Fieldtext name={"content[author]"} label="Author " disabled={false}/>
                  </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                      <Fieldtext name={"content[publication]"} label="Publisher *" disabled={false}/>
                  </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <Field
                      name={"content[publishedDate]"}
                      type="date"
                      component={Formikdatapicker}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      minDate={new Date()}
                      textFieldProps={{
                        variant: "filled",
                        label: "Published Date",
                        InputProps: {
                          readOnly: true,
                          endAdornment: (
                            <InputAdornment position="end">
                              <CalendarTodayIcon />
                            </InputAdornment>
                          )
                        }
                      }}
                    />
                  </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <Field
                      name={"content[readTime]"}
                      type="text"
                      component={FormikTextField}
                      variant="filled"
                      onChange={handleChange}
                      className={classes.inputItem}
                      label="Time *"
                    />
                  </GridItem>
                {(props.location.state === "video" || data)? <>
                  <GridItem md={12} lg={12} sm={12} xs={12}>
                    <Typography className={classes.gridHeader}>
                      <b className={classes.clr_title}>
                        Add Video *
                      </b>
                    </Typography>
                  </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom} style={{paddingBottom:"10px"}}>
                      <Field
                        name={"content[videoUrl]"}
                        type="file"
                        component={formikVideo}
                        variant="filled"
                        onChange={handleChange}
                        className={classes.inputItem}
                        label="Content Article Video *"
                        audio={"video"}
                        inputProps={{accept:"video/MP4,video/*"}}
                        edit={editvalue}
                      />
                  <br/>
                  </GridItem> </> : ""}
                  <GridItem md={12} lg={12} sm={12} xs={12} style={{paddingTop:"30px"}}>
                  </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                       <Typography className={classes.gridHeader}>
                      <b className={classes.clr_title}>
                        Thumbnail Image *
                      </b>
                    </Typography>
                    <Field
                      name={"content[articleImage]"}
                      type="text"
                      component={File}
                      variant="filled"
                      onChange={handleChange}
                      className={classes.inputItem}
                      label="Content Article Image *"
                    />
                    <br/>
                    {errors.content&&touched.content&&errors.content.articleImage&&touched.content.articleImage?
                    <p className={classes.errormessage}>{errors.content.articleImage}</p>:""}
                  </GridItem>
                  <GridItem md={3} lg={3} sm={12} xs={12} className={classes.paddingBottom}></GridItem>
                  <GridItem md={5} lg={5} sm={12} xs={12} className={classes.paddingBottom}>
                    <GridItem md={12} lg={12} sm={12} xs={12} className={classes.paddingBottom}>
                      <Button onClick={()=>handlebody(values.resourceid,errors.resourceid)} className={classes.button} >
                        Content Body *
                      </Button>
                      {errors.content&&touched.content&&touched.content.contentBody&&errors.content.contentBody?
                      <p className={classes.errormessage}>{errors.content.contentBody}</p>:""}
                      {body? (
                        <Bodycontent
                          handleBodysubmit={(value, text) => handleBodysubmit(value, text, setFieldValue)}
                          contentvalue={values["content"]["contentBody"]}
                          open={open}
                          text={Contentbody}
                          handleClose={handleClose}
                          location={props.location.state}
                          resourcesid={values.resourceid}
                        />
                      ) : ( "" )}
                    </GridItem>
                    <GridItem md={12} lg={12} sm={12} xs={12} className={classes.paddingBottom}>
                    <Field
                      name={"content[mediaCaption]"}
                      type="text"
                      component={FormikTextField}
                      variant="filled"
                      onChange={handleChange}
                      className={classes.inputItem}
                      label="Media Caption *"
                    />
                  </GridItem>
                  </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                   <AreaField name={"content[shortDescription]"}  InputProps={{ multiline: true, rows: 4 }}  label="Short Description *"/>
                  </GridItem>
                      <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <AreaField name={"content[disclaimerOne]"}  InputProps={{ multiline: true, rows: 4 }}  label="Disclaimer 1"/>
                  </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
              <AreaField name={"content[disclaimerTwo]"}  InputProps={{ multiline: true, rows: 4 }}  label="Disclaimer 2"/>
                  </GridItem>
                  <GridItem md={12} lg={12} sm={12} xs={12} className={classes.paddingBottom}>
                    <AreaField  name={"content[longDescription]"}  InputProps={{ multiline: true, rows: 4 }} label="Long Description *"/>
                  </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <CategoryTag categoryoption={categoryValue}/>
                  </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                      <TopicTag topictagoption={TopictagarticleValue}/>
                  </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                  <Trigger triggeroptions={triggerValue}/>
                  </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                  <DiseaseSegment diseaseSegmentoptions={diseaseSegmentValue}/>
                  </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                   <TreatmentPhase treatmentPhaseoptions={treatmentPhaseValue}/>
                  </GridItem>
                <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
               <DrugCategory drugCategoryoptions={drugCategoryarticleValue}/>
                </GridItem>
                <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
               <Persona personaoptions={personaArticleValue}/>
                </GridItem>
                    <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                <Objective objectiveoption={objectiveValue}/>
                </GridItem>
                    <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                <Fieldtext name={"veevacontentid"} label="Veeva Content ID*" disabled={true}/>
                </GridItem>
                      <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <Field
                      name="searchtags"
                      type="text"
                      component={FormikTextField}
                      variant="filled"
                      onChange={handleChange}
                      className={classes.inputItem}
                      label="Search Tags *"
                    />
                    <InputLabel>Separate with comma(,) for more than one values</InputLabel>
                  </GridItem>
              </GridContainer>
              </div>
              </div>
              <Paper style={{ marginTop: "40px", width: "100%",boxShadow:"none",padding:"15px"}}>
                <Grid container style={{paddingBottom:'5px'}}>
                  <Grid item lg={9} md={9} sm={6} xs={6} style={{ width: '100%', textAlign: 'right' }}>
                    <Button onClick={handlePreview} className={classes.cancelBtn} >Preview</Button>
                      {openpopup ? (<JsonPreview open={open} handleClose={handleClose} list={values} text={Contentbody}
                      locationsearch={locationsearch} videoform={props.location.state} data={data} /> ) : ( "" )}
                  </Grid>
                  <Grid item lg={3} md={3} sm={6} xs={6} style={{ width: '100%' }}>
                    <Button className={classes.createUser} onClick={() => validateForm().then(arg => { console.log(arg); })} type="submit"  disabled={disablesubmit}>  
                      {load && <CircularProgress color="primary" style={{position: "absolute",right:"40%",top:"-140%"}} />} {"SUBMIT"}</Button>
                  </Grid>
                </Grid>
              </Paper>
            </Form>
          )}
      </Formik>
        {SucessField?props.location.state?<SuccessDialog successButton={InactivatePatientButton} HeaderText={"Success"} BodyText={UpdatedMessage} dismiss={handleCloseDialog}/>
        :<SuccessDialog successButton={InactivatePatientButton} HeaderText={"Success"} BodyText={SuccessMessage} dismiss={handleCloseDialog}/>:""}
        {Errorclose?<ErrorDialog successButton={InactivatePatientButton1}  HeaderText={errorMessage1}  dismiss={handleErrorUser}/>:""}
          {resourceidError?<ErrorDialog successButton={InactivatePatientButton1}  HeaderText={resourceMessage}  dismiss={handleErrorUser}/>:""}
        {ImageErrorclosearticle?<ErrorDialog successButton={InactivatePatientButton1}  HeaderText={imageerrormessage}  dismiss={ handleErrorUser}/>:""}
      </>
  );
};


export default (AuthenticatedPage()(FormikArticleForm));